import { Box } from "@mantine/core"
import { ReactNode } from "react"
import classes from "./page-shell.module.css"

/** Layout-ийн `<Outlet/>`-ийг ороох ажлын талбар. Хуудсууд өөрсдөө дуудах шаардлагагүй. */
export function PageShell({ children }: Readonly<{ children: ReactNode }>) {
  return <Box className={classes.shell}>{children}</Box>
}
